<template>
  <div class="container mx-auto flex items-center pl-1 pr-1.5 sm:px-0">
    <etg-button type="icon" icon="arrow-left" @click="onArrowClick" />
    <div class="relative w-full">
      <etg-input ref="inputRef" :value="searchKeyword" class="flex-1" size="small" @click="onInputClick" @clear="clearSearch" />
      <etg-button type="icon" icon="remove" class="text-gray-50 absolute top-1/2 right-2 -translate-y-1/2" size="mini" @click="clearSearch" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import EtgInput from '@/components/form/etg-input.vue'

import type { EtgInputExposed } from '@/types/component'

interface Props {
  searchKeyword: string
  buttonClass?: string
}

interface Emits {
  (event: 'search', keyword: string): void
  (event: 'clear'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const { searchKeyword } = toRefs(props)

const isDrawerActive = defineModel<boolean>({ default: false })

const inputRef = ref<Nullable<EtgInputExposed>>(null)

const router = useLocaleRouter()

function clearSearch() {
  emit('clear')
}

function onInputClick() {
  isDrawerActive.value = true
  inputRef.value?.blur?.()
}
function onArrowClick() {
  router.push({ name: 'index' })
}
</script>
